module.exports = {
	"$id": "query.json#",
	"$schema": "http://json-schema.org/draft-06/schema#",
	"type": "object",
	"required": [
		"name",
		"value"
	],
	"properties": {
		"name": {
			"type": "string"
		},
		"value": {
			"type": "string"
		},
		"comment": {
			"type": "string"
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/har-schema/lib/query.json
 ** module id = 628
 ** module chunks = 0
 **/